import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <circle cx="12" cy="12.5" r="11.5" fill={props.fill || '#fff'} stroke="#1D252D" strokeOpacity="0.3" strokeWidth="1"></circle>
    </svg>;
}
export default Icon;